import Form from "./Form";

export default class NoData
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `${Form.selector()}__no-data`;

	getForm()
	{
		return new Form(this.el.closest(Form.selector()));
	}

	hide()
	{
		this.el.hidden = true;

		return this;
	}

	show()
	{
		this.el.hidden = false;

		this.getForm().getNavigationItemContainer().hide();
		this.getForm().getShowcaseContainer().showFrequent();

		return this;
	}
}
